import React, {useEffect, useState} from "react";
import SDInput from "./tools/sdInput";
import SDBtn from "./tools/sdBtn";
import { getJourney, userLogin } from "./api";
import './login.scss';

function Login (props) {
  const [acc, setAcc] = useState();
  const [pwd, setPwd] = useState();
  const [cpwd, setCPwd] = useState();
  const [mail, setMail] = useState();
  const [add, setAdd] = useState(false);

  function clickCheck () {
    userLogin({
        "Account": acc,
        "Password": pwd,
        "Mail": ""
    }).then((res) => {
      localStorage.setItem("token", JSON.stringify(res.data.token));

      props.close();
    })
  }

  function newAccount () {
    
  }

  function closeLogin(e) {
    if (e.target.className == "loginAccount") props.close();
  }

  function logout () {
    localStorage.removeItem("token");
  }

  return (
    <div className="loginAccount" onClick={(e) => closeLogin(e)}>
      <div className="loginCenterBar">
        <div className="logblock">
          <div>
            <SDInput label="帳號" change={setAcc} placeholder={'請輸入帳號'}></SDInput>
          </div>
          <div>
            <SDInput label="密碼" change={setPwd} type={'pw'} placeholder={'請輸入密碼'}></SDInput>
          </div>
          <div className="loginBtn">
            <SDBtn label={'登入'} click={clickCheck}></SDBtn>
            <SDBtn label={'登出'} click={logout}></SDBtn>
          </div>
        </div>
        <div className="cusblock">
          {add ?
          <div>
            <div>
              <SDInput label="帳號" change={setAcc} placeholder={'請輸入帳號'}></SDInput>
            </div>
            <div>
              <SDInput label="密碼" change={setAcc} placeholder={'請輸入帳號'}></SDInput>
            </div>
            <div>
              <SDInput label="確認密碼" change={setAcc} placeholder={'請輸入帳號'}></SDInput>
            </div>
            <div>
              <SDInput label="E-Mail" change={setAcc} placeholder={'請輸入帳號'}></SDInput>
            </div>
          </div> : ''}
        <SDBtn label={'開新帳號'} click={() => setAdd(true)} cstyle={{
          fontSize: '12px',
          padding: '5px 10px'
        }}></SDBtn>
        </div>
      </div>
    </div>
  )    
}

export default Login;